import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../navbar/navbar.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'mgp-main',
    // imports: [
    //     RouterModule
    // ],
    templateUrl: './main.component.html',
    imports: [
        NavbarComponent,
        RouterOutlet,
        FooterComponent,
    ],
})
export class MainComponent implements OnInit {
    constructor(
        private titleService: Title,
        private router: Router){}

    ngOnInit(): void {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.updateTitle();
            }
            });
    }

    updateTitle(): void {
        this.titleService.setTitle(this.getPageTitle(this.router.routerState.snapshot.root));
    }

    /**
    * Utility method used from template for retrieving current page title
    * @param routeSnapshot current routing information
    */
    private getPageTitle(routeSnapshot: ActivatedRouteSnapshot): string {
        let title: string = routeSnapshot.data['pageTitle'] ?? '';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    }
}